// extracted by mini-css-extract-plugin
module.exports = {"revertBlock":"styles_revertBlock__2_suw","revertBlock_body":"styles_revertBlock_body__2BM6R"};